<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <!-- //2025-08-29 - prova ISSUE 243 -->
      Last <input @change="updemailfrom()" style="text-align: center; border-radius: 20px; font-weight: bold;  width: 80px; background-color: white; margin-left: 10px; margin-right: 10px;" type="number" v-model="months" min="1" step="1"> month(s)
      <!-- //2025-08-29 - prova ISSUE 243 -->
      <v-flex md12>
        <core-table :emailsfrom="emailsfrom" ref="emailTable" :config="config" hide-upsert title="Email list" @read="showEmail">
        </core-table>
      </v-flex>
    </v-layout>
    <app-email-show-modal v-model="emailModal" :item="item"/>
  </v-container>
</template>

<script>

import config from './config_index.js'
//2025-08-29 - prova ISSUE 243
import moment from 'moment';
//2025-08-29 - prova ISSUE 243
export default {
  data () {
    return { 
      //2025-08-29 - prova ISSUE 243
      months: 6,
      emailsfrom: null,
      //2025-08-29 - prova ISSUE 243
      config,
      item: {},
      emailModal: false,
      timer: null,
    }
  },
  created() {
    //2025-08-29 - prova ISSUE 243
    this.emailsfrom = moment().add((this.months * (-1)), 'months').format('YYYY-MM-DD')
    //this.timer = setInterval(this.updateData, 10000); //gorreta 2025-08-29 da 5000 a 10000
    //2025-08-29 - prova ISSUE 243
    config.setApp(this)
  },
  beforeDestroy () {
    //2025-08-29 - prova ISSUE 243
    //clearInterval(this.timer);
    //2025-08-29 - prova ISSUE 243
  },
  methods: {
    //2025-08-29 - prova ISSUE 243
    updemailfrom()
    {
      this.emailsfrom = moment().add((this.months * (-1)), 'months').format('YYYY-MM-DD')
    },
    //2025-08-29 - prova ISSUE 243
    updateData() {
      this.$refs.emailTable.getData(false, false);
    },
    showEmail(item) {
      this.item = item
      this.emailModal = true
    },
    clicked() {
      this.$root.$emit('openSnackbar', {
        message: 'Content copied to clipboard',
        color: 'success'
      })
    }
  }
}
</script>
